<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.setting.positions')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="row">
                    <div class="col-md-8">
                        <div class="card">
                            <div class="card-header bg-light">
                                <div class="card-title">{{$t('form.setting.staffPositionList')}}</div>
                            </div>
                            <div class="card-body table-responsive p-0">
                                <table class="table table-hover" v-if="staffPositions.length">
                                    <thead>
                                        <tr class="header">
                                            <th>{{$t('form.setting.name')}}</th>
                                            <th class="text-right">{{$t('form.setting.action')}}</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr v-for="(position, index) in staffPositions" :key="index">
                                            <td>{{position.name}}</td>

                                            <td class="text-right">
                                                <button v-if="permissions.editSettingsPositions"
                                                    class="btn btn-info btn-sm" @click="edit(position, 'staff')">
                                                    <i class="fas fa-edit"></i>
                                                </button>
                                                <button v-if="permissions.deleteSettingsPositions"
                                                    class="btn btn-danger btn-sm" @click="remove(position, index)">
                                                    <i class="fas fa-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <p class="p-3 m-0" v-else>{{$t('noRecord')}}</p>
                            </div>

                            <pagination v-if="staffPositionPagination.last_page > 1"
                                :pagination="staffPositionPagination" :offset="5" @paginate="paginate()">
                            </pagination>
                        </div>
                    </div>

                    <div class="col-md-4">
                        <div class="card" v-if="toggleForm">
                            <div class="card-header bg-light">
                                <div class="card-title">{{$t('form.setting.positionCreate')}}</div>
                            </div>
                            <div class="card-body">
                                <div class="form-group">
                                    <label>{{$t('form.setting.name')}}</label>
                                    <input type="text" class="form-control" v-model="name">
                                </div>

                                <b-form-group :label="$t('form.setting.addInList')">
                                    <b-form-radio v-model="type" value="staff">{{$t('form.setting.inputStaff')}}
                                    </b-form-radio>
                                    <b-form-radio v-model="type" value="professor">{{$t('form.setting.inputProfessor')}}
                                    </b-form-radio>
                                </b-form-group>

                                <b-button variant="primary" @click="submit">{{$t('button.save')}}</b-button>
                            </div>
                        </div>

                        <div class="card" v-else>
                            <div class="card-header bg-light">
                                <div class="card-title">{{$t('form.setting.positionEdit')}}</div>
                            </div>
                            <div class="card-body">
                                <div class="form-group">
                                    <label>{{$t('form.setting.name')}}</label>
                                    <input type="text" class="form-control" v-model="name">
                                </div>

                                <b-button variant="primary" @click="update">{{$t('button.update')}}</b-button>
                                <b-button variant="outline-primary" @click="cancel">{{$t('button.cancel')}}</b-button>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-8">
                        <div class="card">
                            <div class="card-header bg-light">
                                <div class="card-title">{{$t('form.setting.professorPositionList')}}</div>
                            </div>
                            <div class="card-body table-responsive p-0">
                                <table class="table table-hover" v-if="professorPositions.length">
                                    <thead>
                                        <tr class="header">
                                            <th>{{$t('form.setting.name')}}</th>
                                            <th class="text-right">{{$t('form.setting.action')}}</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr v-for="(position, index) in professorPositions" :key="index">
                                            <td>{{position.name}}</td>

                                            <td class="text-right">
                                                <button v-if="permissions.editSettingsPositions"
                                                    class="btn btn-info btn-sm" @click="edit(position, 'professor')">
                                                    <i class="fas fa-edit"></i>
                                                </button>
                                                <button v-if="permissions.deleteSettingsPositions"
                                                    class="btn btn-danger btn-sm"
                                                    @click="remove(position, index, 'professor')">
                                                    <i class="fas fa-trash"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <p class="p-3 m-0" v-else>{{$t('noRecord')}}</p>
                            </div>

                            <pagination v-if="profPositionPagination.last_page > 1" :pagination="profPositionPagination"
                                :offset="5" @paginate="paginate('professor')">
                            </pagination>
                        </div>
                    </div>
                </div>

                <div class="row">

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['permissions', 'dateFormat'],

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,
                toggleForm: true,

                staffPositionPagination: {
                    current_page: 1
                },
                profPositionPagination: {
                    current_page: 1
                },

                name: '',
                id: '',
                type: 'staff',

                staffPositions: [],
                professorPositions: []
            }
        },

        mounted() {
            if (!this.permissions.viewSettingsPositions) {
                return this.$router.push('/');
            }

            this.getStaffPositions();
            this.getProfessorPositions();
        },

        methods: {

            getProfessorPositions() {
                this.isLoading = true;

                axios
                    .get('/api/positions?type=professor&page=' + this.profPositionPagination.current_page)
                    .then(response => {
                        this.professorPositions = response.data.data.data;
                        this.profPositionPagination = response.data.pagination;
                        this.isLoading = false;
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error');
                    });
            },

            getStaffPositions() {
                this.isLoading = true;

                axios
                    .get('/api/positions?type=staff&page=' + this.staffPositionPagination.current_page)
                    .then(response => {
                        this.staffPositions = response.data.data.data;
                        this.staffPositionPagination = response.data.pagination;
                        this.isLoading = false;
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error');
                    });
            },

            paginate(type = null) {

                if (type) {
                    this.getProfessorPositions();
                    return;
                }

                this.getStaffPositions();
            },

            submit() {
                if (this.name == '') {
                    this.showAlert('Please add name to continue.', 'danger');
                    return;
                }

                this.clear();
                this.isLoading = true;

                axios
                    .post(`/api/positions`, {
                        name: this.name,
                        type: this.type
                    })
                    .then(response => {

                        if (response.data.success) {
                            this.name = '';
                            this.showAlert(response.data.message);

                            if (this.type == 'staff') {
                                this.staffPositions.unshift(response.data.data);
                            } else {
                                this.professorPositions.unshift(response.data.data);
                            }
                        }

                        this.isLoading = false;
                    })
                    .catch(error => {
                        if (error.response.data.error) {
                            this.showAlert(error.response.data.message, 'danger');
                        }

                        this.isLoading = false;
                    })
            },

            edit(item, type) {
                this.id = item.id;
                this.name = item.name;
                this.type = type;
                this.toggleForm = false;
            },

            update() {
                if (this.name == '') {
                    this.showAlert('Please add name to continue.', 'danger');
                    return;
                }

                this.clear();
                this.isLoading = true;

                axios
                    .put(`/api/positions/${this.id}`, {
                        name: this.name,
                        type: this.type
                    })
                    .then(response => {
                        if (response.data.success) {
                            this.showAlert(response.data.message);

                            if (this.type == 'professor') {
                                this.professorPositions.map(r => {
                                    if (r.id == this.id) {
                                        r.id = response.data.data.id;
                                        r.name = response.data.data.name;
                                    }
                                });
                            } else {
                                this.staffPositions.map(r => {
                                    if (r.id == this.id) {
                                        r.id = response.data.data.id;
                                        r.name = response.data.data.name;
                                    }
                                });
                            }

                            this.cancel();
                        }

                        this.isLoading = false;
                    })
                    .catch(error => {
                        if (error.response.data.error) {
                            this.showAlert(error.response.data.message, 'danger');
                        }

                        this.isLoading = false;
                    })
            },

            cancel() {
                this.id = '';
                this.name = '';
                this.type = 'staff';
                this.toggleForm = true;
            },

            remove(item, index, type = null) {
                if (!confirm(this.$t('form.validation.delete'))) {
                    return;
                }

                this.clear();
                this.isLoading = true;

                axios
                    .delete(`/api/positions/${item.id}`)
                    .then(response => {
                        this.isLoading = false;

                        if (response.data.success) {
                            this.showAlert(response.data.message);

                            if (type) {
                                this.professorPositions.splice(index, 1);
                                return;
                            }

                            this.staffPositions.splice(index, 1);
                        }
                    })
                    .catch(error => {
                        if (error.response.status === 422) {
                            this.showAlert(error.response.data.message, 'danger');
                        }

                        this.isLoading = false;
                    })
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            },

            clear() {
                this.alert = false;
                this.message = '';
                this.alertClass = '';
            }
        }
    }

</script>
